import script from "./pattern-memory.vue?vue&type=script&setup=true&lang=ts"
export * from "./pattern-memory.vue?vue&type=script&setup=true&lang=ts"

import "./pattern-memory.vue?vue&type=style&index=0&id=53868e6e&lang=scss"

const __exports__ = script;

export default __exports__